import * as React from 'react';
import { Collapse, CardBody, CardHeader, Table, Card, Button, CardTitle, CardText, Row, Col, Progress, Label, Spinner, Input } from 'reactstrap';
import Select from 'react-select';
import { useAppDispatch, useAppSelector } from '../hooks/index';
import { ensureAfrsForYear } from '../redux/EntitiesSlice';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Page from './Page';
import CreateReportsCore from '../components/AfrCore/CreateReportsCore'
import { TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';


const CreateAFRs = () => {
    return (
        <React.Fragment>
            <CreateReportsCore taxonomyType={TaxonomyTypeEnum.AFR} reportName="AFR" logicalPeriods={[]} />
        </React.Fragment>
    );
}
export default CreateAFRs;
